import { useEffect, useRef } from 'react'

import { useDispatch, useSelector } from 'react-redux'

import { boxSummaryDeliverySlotChosen } from 'actions/boxSummary'
import { getHasProspectNotSeenWizard } from 'routes/Menu/selectors/menu'
import { getTempDeliveryOptions } from 'utils/deliverySlotHelper'

export const useProspectTempDeliverySlot = () => {
  const hasChosenSlotRef = useRef(false)
  const dispatch = useDispatch()
  const hasProspectNotSeenWizard = useSelector(getHasProspectNotSeenWizard)
  const { tempDate, tempSlotId } = useSelector(getTempDeliveryOptions)

  useEffect(() => {
    if (hasChosenSlotRef.current) return
    if (!hasProspectNotSeenWizard || !tempSlotId || !tempDate) return

    dispatch(boxSummaryDeliverySlotChosen({ slotId: tempSlotId, date: tempDate }))
    hasChosenSlotRef.current = true
  }, [dispatch, hasProspectNotSeenWizard, tempDate, tempSlotId])
}
